import React from "react";
import SectionHeading from "../components/SectionHeading";
import { galleryPhoto } from "../config/images";

/**
 * Gallery page
 * Props:
 *  - content: siteContent.gallery
 */
function Gallery({ content }) {
  return (
    <>
      <section className="hero-section py-5">
        <div className="container text-center">
          <h1 className="fw-bold display-6 mb-2">{content.title}</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{content.subtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Memories" title="Community Moments" />
          <div className="row g-4">
            {content.images.map((img, idx) => (
              <div className="col-sm-6 col-lg-4 gallery-item" key={idx}>
                <img src={galleryPhoto(img.src)} alt={img.alt} className="gallery-img" />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;
